import { AutogenModelOpportunity, AutogenRowOpportunity } from "./autogen/AutogenModelOpportunity";

export class ModelOpportunity extends AutogenModelOpportunity<RowOpportunity> {
	constructor() {
		super(RowOpportunity);
	}
}

export class RowOpportunity extends AutogenRowOpportunity {
}